export interface ShiftRosterEntry {
    readonly id: number;
    readonly shiftId: number;
    readonly shiftName: string;
    /** ISO date (yyyy-MM-dd) the shift starts on. */
    readonly shiftDate: string;
    readonly userId: string;
    readonly fullName?: string | null;
    readonly email?: string | null;
    readonly role: string;
}
